function BigScrollText() {
	this.build();
}

BigScrollText.prototype.build = function () {
	const bigScrollText = document.querySelectorAll('.big-scroll-text');
	bigScrollText.forEach(function (elem) {
		elem.style.animationDuration = Math.round(elem.textContent.length + 10) + 's';
	});
};
